import React, { useState } from 'react';
import { Autocomplete, Button, Grid, TextField } from '@mui/material';
import { handleError, handleWarning } from '../../helpers/utils';
import { getClients } from '../../actions/client';

const FILTER_OPTIONS = ['Nombre', 'Banco', 'Estado', 'Ciudad', 'RFC'];

export const SearcherClient = ({
	generateRows = null,
	handleClose = null,
	rowsState = 5,
	setRowsState = null,
}) => {
	// Searcher
	const [searchField, setSearchField] = useState('');
	const [selectedOption, setSelectedOption] = useState(null);

	const handleSearch = () => {
		if (searchField === '') {
			handleWarning('Hacen falta campos para poder buscar');
		} else {
			const endpoint = `/api/client/?ordering=-created_at&search=${searchField}`;
			getClients(`${endpoint}&page_size=${rowsState.pageSize}`)
				.then(({ data }) => {
					generateRows(data);
					setRowsState((old) => ({
						...old,
						next: data.next,
						previous: data.previous,
						current: endpoint,
					}));
				})
				.catch((error) => {
					handleError(error, 'No se pudo realizar la búsqueda');
					generateRows(null);
				});
		}
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	return (
		<Grid
			container
			component='main'
			spacing={1}
			style={{
				width: '50%',
				margin: '10px 0 15px 0',
			}}
		>
			<Grid item xs={4.2}>
				<Autocomplete
					required
					fullWidth
					style={{
						width: '100%',
						margin: '-17px auto',
					}}
					value={selectedOption}
					onChange={(_, value) => {
						setSelectedOption(value);
					}}
					options={FILTER_OPTIONS}
					renderInput={(params) =>
						TextFieldComponent(params, 'Buscar por')
					}
				/>
			</Grid>

			<Grid item xs={4}>
				<TextField
					required
					style={{ margin: '0 auto' }}
					label='Valor'
					value={searchField}
					onChange={({ target }) => setSearchField(target.value)}
					onKeyDown={({ key }) => {
						if (key === 'Enter') {
							handleSearch();
						}
					}}
				/>
			</Grid>

			<Grid item xs={4}>
				<Button variant='text' onClick={handleSearch}>
					Buscar
				</Button>
				<Button
					color='error'
					variant='text'
					onClick={() => {
						generateRows(null);
						handleClose();
					}}
				>
					Cerrar
				</Button>
			</Grid>
		</Grid>
	);
};
